import { useEffect, useState } from "react";
import { onNavigate } from "../lib/router";
import { ShareLandingRoute } from "./ShareLandingRoute";
import { ExpiredRoute } from "./ExpiredRoute";
import { AdminLoginRoute } from "./AdminLoginRoute";
import { AdminRoute } from "./AdminRoute";
import { MapRoute } from "./MapRoute";

function useLocation() {
  const [loc, setLoc] = useState({ pathname: location.pathname, search: location.search });
  useEffect(() => {
    return onNavigate(() =>
      setLoc({ pathname: location.pathname, search: location.search }));
  }, []);
  return loc;
}

export function Router() {
  const { pathname } = useLocation();

  if (pathname === "/expired") return <ExpiredRoute />;
  if (pathname === "/admin/login") return <AdminLoginRoute />;
  if (pathname === "/admin" || pathname.startsWith("/admin/")) return <AdminRoute />;
  if (pathname.startsWith("/s/")) {
    const slug = pathname.slice(3);
    return <ShareLandingRoute slug={slug} />;
  }
  return <MapRoute />;
}
